var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{staticClass:"widget-details-view",attrs:{"widget":_vm.widget,"shell-style":{
    left: ((this.dashboard.left + 8) + "px"),
    top: ((this.dashboard.top + 8) + "px"),
    width: ((this.dashboard.width) + "px"),
    height: ((this.dashboard.height) + "px"),
    transformOrigin: ((this.shellOrigin.x) + "px " + (this.shellOrigin.y) + "px")
  },"details":""},on:{"close":function($event){return _vm.close()}}})}
var staticRenderFns = []

export { render, staticRenderFns }